/**
 * Zustand store для UI состояния
 */

import { create } from 'zustand';

/**
 * Состояние UI
 */
interface UIState {
  /** Виджет открыт */
  isOpen: boolean;
  
  /** Виджет минимизирован */
  isMinimized: boolean;
  
  /** Показывать welcome screen */
  showWelcome: boolean;
  
  /** Показывать badge уведомления */
  showBadge: boolean;
  
  /** Прогресс загрузки файла (0-100) */
  uploadProgress: number;
  
  /** Показывать contacts dropdown */
  showContacts: boolean;
}

/**
 * Действия для UI
 */
interface UIActions {
  /** Открыть виджет */
  open: () => void;
  
  /** Закрыть виджет */
  close: () => void;
  
  /** Переключить открытие/закрытие */
  toggle: () => void;
  
  /** Установить минимизацию */
  setMinimized: (minimized: boolean) => void;
  
  /** Установить welcome screen */
  setShowWelcome: (show: boolean) => void;
  
  /** Установить badge */
  setShowBadge: (show: boolean) => void;
  
  /** Установить прогресс загрузки */
  setUploadProgress: (progress: number) => void;
  
  /** Установить состояние contacts */
  setShowContacts: (show: boolean) => void;
}

/**
 * Тип всего store
 */
type UIStore = UIState & UIActions;

/**
 * Zustand store для UI
 */
export const useUIStore = create<UIStore>((set) => ({
  // Начальное состояние
  isOpen: false,
  isMinimized: false,
  showWelcome: true,
  showBadge: false,
  uploadProgress: 0,
  showContacts: false,

  // Actions
  open: () => {
    set({ isOpen: true, showBadge: false });
  },

  close: () => {
    set({ isOpen: false, isMinimized: false });
  },

  toggle: () => {
    set((state) => ({
      isOpen: !state.isOpen,
      showBadge: state.isOpen ? state.showBadge : false,
    }));
  },

  setMinimized: (minimized) => {
    set({ isMinimized: minimized });
  },

  setShowWelcome: (show) => {
    set({ showWelcome: show });
  },

  setShowBadge: (show) => {
    set({ showBadge: show });
  },

  setUploadProgress: (progress) => {
    set({ uploadProgress: progress });
  },

  setShowContacts: (show) => {
    set({ showContacts: show });
  },
}));

